export enum DateFormat {
  TIME = 'time',
  DATE = 'date',
  DATE_TIME = 'dateTime',
  DATE_TIME_SHORT = 'dateTimeShort',
  DATE_SHORT = 'dateShort',
  DATE_TIME_WITH_MONTH = 'dateTimeWithMonth',
  DATE_OF_BIRTH = 'dateOfBirth',
  CONSULTATION_LOG_DATE = 'consultationLogDate',
  CONSULTATION_LOG_DATE_TIME = 'consultationLogDateTime',
  FILE_UPLOADED_AT_DATE_TIME = 'fileUploadedAtDateTime',
  TODAY_DATE_TIME = 'todayDateTime',
  BEFORE_TODAY_DATE_TIME = 'beforeTodayDateTime',
  FULL_DATE = 'fullDate'
}
